/**
 * 매장 상세 페이지 UI 상태 (바텀시트, 툴팁, 선택 리뷰/상품 등).
 * store page 전용 hook.
 */
import { useState } from "react";
import type { ReviewModalData } from "../../../components/review/review-detail-modal";

export interface SelectedProductForQuantity {
  id: number;
  name: string;
  price: number;
  userPrice: number;
  currentCount: number;
}

export function useStorePageState() {
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  const [selectedReview, setSelectedReview] = useState<ReviewModalData | null>(null);
  const [isTimeSaleTooltipOpen, setIsTimeSaleTooltipOpen] = useState(false);
  const [isQuantitySheetOpen, setIsQuantitySheetOpen] = useState(false);
  const [selectedProductForQuantity, setSelectedProductForQuantity] =
    useState<SelectedProductForQuantity | null>(null);
  const [isReserveConfirmOpen, setIsReserveConfirmOpen] = useState(false);
  const [isTomorrowForConfirm, setIsTomorrowForConfirm] = useState(false);
  const [isLoginSheetOpen, setIsLoginSheetOpen] = useState(false);

  return {
    isSheetOpen,
    setIsSheetOpen,
    selectedReview,
    setSelectedReview,
    isTimeSaleTooltipOpen,
    setIsTimeSaleTooltipOpen,
    isQuantitySheetOpen,
    setIsQuantitySheetOpen,
    selectedProductForQuantity,
    setSelectedProductForQuantity,
    isReserveConfirmOpen,
    setIsReserveConfirmOpen,
    isTomorrowForConfirm,
    setIsTomorrowForConfirm,
    isLoginSheetOpen,
    setIsLoginSheetOpen,
  };
}
